import endpoints from './endpoints';
import {throttled, fetch} from '~/lib/fetch';

const fleet = {
  contract: async (id) => {
    const result = await fetch(`${endpoints.fleet}/contract`, {
      method: 'POST',
      body: JSON.stringify({id}),
    });

    if (!result) {
      return null;
    }

    const json = await result.json();
    return json;
  },
  contract_by_license: async (license, dealer_id) => {
    const result = await fetch(`${endpoints.fleet}/contract`, {
      method: 'POST',
      body: JSON.stringify({license, dealer_id}),
    });

    if (!result) {
      return null;
    }

    const json = await result.json();
    return json;
  },
  contracts_by_reference: throttled(async (signal, dealer_id, reference) => {
    const result = await fetch(
      `${endpoints.fleet}/contracts/${dealer_id}/${encodeURIComponent(
        reference,
      )}`,
      {
        signal,
      },
    );

    if (!result) {
      return null;
    }

    const json = await result.json();
    return json;
  }),
  request: async (id, partial_vin, current_mileage) => {
    const result = await fetch(`${endpoints.fleet}/${id}`, {
      method: 'POST',
      body: JSON.stringify({partial_vin, current_mileage}),
    });

    if (!result) {
      return null;
    }

    const json = await result.json();
    return json;
  },
  invoice: async (id, pdf) => {
    const result = await fetch(`${endpoints.fleet}/${id}/invoice`, {
      method: 'POST',
      body: JSON.stringify({pdf}),
    });

    if (!result) {
      return null;
    }

    const json = await result.json();
    return json;
  },
  request_replacement_vehicle: async (request_id, replacement) => {
    const result = await fetch(
      `${endpoints.fleet}/${request_id}/replacement_vehicle`,
      {
        method: 'POST',
        body: JSON.stringify({...replacement}),
      },
    );

    if (!result) {
      return {success: false};
    }

    const json = await result.json();
    return json;
  },
  replacement_vehicle: async (request_id) => {
    const result = await fetch(
      `${endpoints.fleet}/${request_id}/replacement_vehicle`,
    );

    if (!result) {
      return {success: false};
    }

    const json = await result.json();
    return json;
  },
  cancel_replacement_vehicle: async (request_id, replacement) => {
    const result = await fetch(
      `${endpoints.fleet}/${request_id}/replacement_vehicle`,
      {
        method: 'DELETE',
        body: JSON.stringify({...replacement}),
      },
    );

    if (!result) {
      return {success: false};
    }

    const json = await result.json();
    return json;
  },
  invoice_pdf: async (id) => {
    const response = await fetch(`${endpoints.fleet}/${id}/invoice/pdf`);

    if (!response) {
      return null;
    }

    const blob = new Blob([await response.blob()], {
      type: 'application/pdf',
    });

    return blob;
  },
};

export default fleet;
